import DatePicker from "common/DatePicker/DatePicker";
import Title from "common/Typography/Title";
import Card from "common/Boxes/Card";
import Flex from "common/Boxes/Flex";
import BarChart from "common/Charts/BarChart";
import EarningsEmptyState from "features/affiliation/common/EarningsEmptyState";
import { DISPLAY_CURRENCIES } from "common/constants";
import { useMemo } from "react";
import { useEarningsBarChart } from "features/affiliation/common/hooks";
import dayjs from "dayjs";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

interface EarningsByMonthBarChartProps {
  inOverview?: boolean;
}

const EarningsByMonthBarChart = ({
  inOverview,
}: EarningsByMonthBarChartProps) => {
  const {
    earningsChartQuery,
    formattedBarChartData,
    onDataPickerChange,
    commissions,
  } = useEarningsBarChart();
  const showEmptyState = !commissions?.length;
  const loading = earningsChartQuery.isFetching;

  const memoizedBarChart = useMemo(
    () => (
      <BarChart
        data={formattedBarChartData}
        loading={loading}
        usePositiveNegativeColorScheme={true}
        precision={2}
        displayCurrency={DISPLAY_CURRENCIES.USD}
      />
    ),
    [formattedBarChartData, loading]
  );

  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);
  return (
    <Card
      style={{
        maxHeight: inOverview ? "100%" : 400,
        height: inOverview ? "100%" : "50%",
      }}
    >
      <Flex>
        <Title level={3} type="secondary">
          {t("earnings.by_month")}
        </Title>
        <DatePicker
          defaultValue={dayjs()}
          onChange={onDataPickerChange}
          picker="month"
          allowClear={false}
          style={{ width: "auto" }}
        />
      </Flex>
      <div style={{ height: "85%", marginTop: 12 }}>
        {showEmptyState ? <EarningsEmptyState /> : memoizedBarChart}
      </div>
    </Card>
  );
};

export default EarningsByMonthBarChart;
